
import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import Icon from './Icon';

interface LegalModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const LegalModal: React.FC<LegalModalProps> = ({ isOpen, onClose }) => {
    const { t } = useLanguage();

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-md">
            <div className="w-full max-w-lg bg-slate-900 border border-amber-400/30 rounded-2xl shadow-2xl overflow-hidden flex flex-col">
                <div className="p-6 border-b border-amber-400/20 flex justify-between items-center bg-black/20">
                    <h2 className="text-2xl font-display font-bold text-amber-300 flex items-center gap-3">
                        <Icon name="diamond" className="w-6 h-6" />
                        {t('termsAndRules')}
                    </h2>
                    <button onClick={onClose} className="text-slate-400 hover:text-white transition-colors">
                        <Icon name="close" className="w-6 h-6" />
                    </button>
                </div>
                
                <div className="p-6 overflow-y-auto max-h-[60vh] space-y-4 text-slate-300">
                    <section>
                        <p className="text-sm leading-relaxed">{t('termsUsage')}</p>
                    </section>
                    <section>
                        <p className="text-sm leading-relaxed">{t('termsCredits')}</p>
                    </section>
                    <section>
                        <p className="text-sm leading-relaxed">{t('termsLimits')}</p>
                    </section>
                    <section>
                        <p className="text-sm leading-relaxed">{t('termsPrivacy')}</p>
                    </section>
                    <div className="pt-4 border-t border-slate-800 text-xs text-slate-500 italic">
                        All designs generated are property of the user, however, Bhava Jeweltech reserves the right to monitor usage for platform integrity.
                    </div>
                </div>

                <div className="p-4 bg-black/20 text-right">
                    <button 
                        onClick={onClose}
                        className="px-6 py-2 bg-amber-400 text-slate-900 font-bold rounded-lg hover:bg-amber-300 transition-colors"
                    >
                        {t('close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LegalModal;
